import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {selToken} from "../../../stores/base/baseSlice";
import useValidation from "../../../validation/useValidation";
import axios from "axios";
import {strings} from "../../../strings";
import {notification} from "../../functions/notification/notificationFunction";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import {
    initProductTypeForm,
    onProductTypeFormChange,
    selAttributes,
    selProductTypeForm
} from "../../../stores/productType/slice";
import {productTypeValidations} from "../../../stores/productType/model";
import Autocomplete from "@mui/material/Autocomplete";
import {getAttributes, postProductType} from "../../../stores/productType/thunk";

export default function ProductType() {

    const productType = useSelector(selProductTypeForm);
    const allAttributes = useSelector(selAttributes);
    const {
        name,
        attributes,
        title,
    } = productType;
    const dispatch = useDispatch();
    const {slug} = useParams();
    const history = useHistory();
    const token = useSelector(selToken);

    useEffect(() => {
        dispatch(getAttributes())
        return () => {
            dispatch(initProductTypeForm())
        }
    }, [])


    const {errors, checkFiled, checkValidation} = useValidation({
        data: productTypeValidations,
        key: 'productTypeForm',
    });

    const redirectToProductTypes = () => history.push('/productTypes');

    async function handleNext() {
        const check = await checkValidation(productType);
        if (!check) return dispatch(notification("error", "", <h3>برخی از فیلدها خالی هستند</h3>, false))
        const formData = new FormData();
        const dataTable = {
            name: name,
            title: title,
            attribute_ids: attributes
        };
        for (let keyName in dataTable) {
            if (keyName === "attribute_ids") {
                dataTable[keyName].map((x, i) => (
                    formData.append(`attribute_ids[${i}]`, x.id)
                ))
            } else formData.append(keyName, dataTable[keyName]);
        }
        dispatch(postProductType(formData, redirectToProductTypes))
    }


    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onProductTypeFormChange({name, value}))
    }


    function backToProductTypes() {
        history.push('/productTypes');
    }

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن نوع محصول"
                backBtnTitle="بازگشت"
                backBtnAction={backToProductTypes}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">
                    {/*<div className="d-flex flex-column divParentBasicInformation">*/}
                    {/*    {findContent(activeStep)}*/}
                    {/*</div>*/}
                    <div className="w-100">
                        <div className="d-flex flex-column divParentBasicInformation">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام محصول'}
                                        variant="outlined"
                                        name={'name'}
                                        value={name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        limitTags={1}
                                        multiple
                                        id="checkboxes-tags-demo"
                                        className="w-100"
                                        size=""
                                        value={allAttributes.filter(x => attributes.some(({id}) => x.id === id))}
                                        options={allAttributes}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.label}
                                        onChange={(event, value) => {
                                            checkFiled('attributes', value);
                                            dispatch(onProductTypeFormChange({name: 'attributes', value: value}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       error={errors?.attributes?.length > 0}
                                                       variant="outlined"
                                                       label="ویژگی های محصول"
                                                       placeholder="انتخاب ویژگی"/>
                                        )}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان محصول (انگلیسی)'}
                                        variant="outlined"
                                        name={'title'}
                                        value={title}
                                        error={errors.title}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>

                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={handleNext}
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            ایجاد
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
